import createIcon from '../../createIcon';

/**
 * @component @name NewReleases
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMTEuOTk1MkwyMC41NiA5LjIxNTE2TDIwLjkgNS41MzUxNkwxNy4yOSA0LjcxNTE2TDE1LjQgMS41MzUxNkwxMiAyLjk5NTE2TDguNiAxLjUzNTE2TDYuNzEgNC43MTUxNkwzLjEgNS41MjUxNkwzLjQ0IDkuMjA1MTZMMSAxMS45OTUyTDMuNDQgMTQuNzc1MkwzLjEgMTguNDY1Mkw2LjcxIDE5LjI4NTJMOC42IDIyLjQ2NTJMMTIgMjAuOTk1MkwxNS40IDIyLjQ1NTJMMTcuMjkgMTkuMjc1MkwyMC45IDE4LjQ1NTJMMjAuNTYgMTQuNzc1MkwyMyAxMS45OTUyWk0xMyAxNi45OTUySDExVjE0Ljk5NTJIMTNWMTYuOTk1MlpNMTMgMTIuOTk1MkgxMVY2Ljk5NTE2SDEzVjEyLjk5NTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NewReleases = createIcon('NewReleases', [
  [
    'path',
    {
      d: 'M23 11.9952L20.56 9.21516L20.9 5.53516L17.29 4.71516L15.4 1.53516L12 2.99516L8.6 1.53516L6.71 4.71516L3.1 5.52516L3.44 9.20516L1 11.9952L3.44 14.7752L3.1 18.4652L6.71 19.2852L8.6 22.4652L12 20.9952L15.4 22.4552L17.29 19.2752L20.9 18.4552L20.56 14.7752L23 11.9952ZM13 16.9952H11V14.9952H13V16.9952ZM13 12.9952H11V6.99516H13V12.9952Z',
      key: '4tlmrr',
    },
  ],
]);

export default NewReleases;
